module.exports = __webpack_public_path__ + "static/media/hamburger-icon.8c836f15.svg";